// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import type { TypographyProps } from '@iheartjane/reefer';
import { Typography } from '@iheartjane/reefer';

export interface HighlightedTextProps extends TypographyProps {
  children: string;
  highlight?: string;
}

const HighlightedSpan = styled('span')(({ theme }) => ({
  '&:before': {
    backgroundColor: theme.colors.tertiary.seafoam.light,
    borderRadius: 4,
    bottom: -4,
    content: '""',
    left: -4,
    position: 'absolute',
    right: -4,
    top: -4,
    zIndex: -1,
  },
  display: 'inline',
  position: 'relative',
  zIndex: 0,
}));

const InlineTypography = styled('span')({
  display: 'inline',
  position: 'relative',
  zIndex: 1,
});

export const HighlightedText = ({
  children,
  highlight = '',
  ...rest
}: HighlightedTextProps) => {
  const position = children.toLowerCase().search(highlight.toLowerCase());
  if (!!highlight && position >= 0) {
    const substring = children.substring(position, position + highlight.length);
    const pre = children.substring(0, position);
    const post = children.substring(position + highlight.length);
    const tokens = [pre, substring, post].filter((x) => x.length > 0);
    return (
      <Typography aria-label={children} {...rest}>
        {tokens.map((token, index) =>
          token.toLowerCase() === highlight.toLowerCase() ? (
            <HighlightedSpan key={`${highlight}-${token}-${index}`}>
              {token}
            </HighlightedSpan>
          ) : (
            <InlineTypography key={`${token}-${index}`} {...rest}>
              {token}
            </InlineTypography>
          )
        )}
      </Typography>
    );
  }
  return <Typography {...rest}>{children}</Typography>;
};
